<mat-tab-group (selectedIndexChange)="emitFilterChange($event)">
  <mat-tab *ngFor="let option of options" [label]="option.name"> </mat-tab>
</mat-tab-group>
